import { render, staticRenderFns } from "./MessengerFull.vue?vue&type=template&id=ea00ca50&scoped=true&"
import script from "./MessengerFull.vue?vue&type=script&lang=js&"
export * from "./MessengerFull.vue?vue&type=script&lang=js&"
import style0 from "./MessengerFull.vue?vue&type=style&index=0&id=ea00ca50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea00ca50",
  null
  
)

export default component.exports